<template>
    <div>
        <iframe id="idTramite" :src="cUrlTramite" style="width: 100% !important; height: 1000px;" />
    </div>
</template>
<script>
import {mapState} from 'vuex';
export default {
    name: 'PlanEstudio',
    computed: {
        ...mapState(['ssUser']),
        cUrlTramite: function () {
            return 'https://intranetiframe.khipu.edu.pe/planestudios/'+this.ssUser.IdPersonal;
        },
    },
}
</script>
